import React, {Component, PropTypes} from 'react'
import moment from 'moment'
import {Tooltip, OverlayTrigger} from 'react-bootstrap'
import extract from '../../core/extract'
import Strip from '../../core/components/Strip'
import Icon from '../../core/components/Icon'
import i18n from '../i18n'
import style from './TodoStrip.less'

function durationStatus(duration) {
    if (duration && duration > (12 * 3600 * 1000)) return 'success'
    if (duration && duration > 0) return 'warning'
    if (duration) return 'danger'
    return 'success'
}

class TodoStrip extends Component {
    static propTypes = {
        todo: PropTypes.object.isRequired,
        authenticated: PropTypes.object.isRequired
    }

    render() {
        const {todo, authenticated, ...others} = this.props

        const expectedDuration = todo.expectedDate && (new Date(todo.expectedDate) - new Date())

        const tooltip = (text, status) => {
            return (
                <Tooltip className={status && 'tooltip-' + status}>
                    {text}
                </Tooltip>
            )
        }

        const status = durationStatus(expectedDuration)

        const header = (
            <h5 className={style.header}>
                <div className={style.side}>ticket <small>n° {todo.ticket.ref || todo.ticket.uid}</small></div>
                <div className={style.container}>{todo.clientCompany.label}</div>
            </h5>
        )

        const help = todo.operators.find((o) => o.uid == authenticated.uid) && (
            <OverlayTrigger
                placement='bottom'
                overlay={tooltip(i18n.youAreOperator, status)}>
                <Icon active icon='user' size='sm' />
            </OverlayTrigger>
        )

        return (
            <div className={style.default}>
                <Strip
                    header={header}
                    help={help}
                    status={status}
                    {...others}>
                    <div className={style.body}>
                        <p>{todo.ticket.openingTicketPurpose.callPurpose}</p>
                        <p>{extract(i18n.expectedCommandEnum, todo.expectedCommand)}</p>
                        <p className={style.expectedDuration}>
                            {!!expectedDuration && (
                                <span>{moment.duration(expectedDuration).humanize()}</span>
                            )}
                            {expectedDuration < 0 && (
                                <small> ({i18n.overdue})</small>
                            )}
                        </p>
                    </div>
                </Strip>
            </div>
        )
    }
}

export default TodoStrip


// WEBPACK FOOTER //
// ./lib/workflow/components/TodoStrip.js